export default __webpack_public_path__ + "static/media/Snd_1.402d0b73.mp3";